import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { Language } from '@auth/login/data/login.model';
import { LoginMessagesEntry } from '@portal-management/login-messages/data/login-message.model';
import { SessionFacade } from '@shared/store/session.facade';

@Component({
  selector: 'eop-login-notification',
  templateUrl: './login-notification.component.html',
  styleUrls: ['./login-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginNotificationComponent {
  private readonly sessionFacade = inject(SessionFacade);

  @Input()
  activeMessages: LoginMessagesEntry[];

  @Input()
  userLanguage: Language;

  @Output()
  markNotificationsSeen = new EventEmitter<void>();

  messagesShown$ = this.sessionFacade.messagesShown$;

  closeMessages(): void {
    this.markNotificationsSeen.emit();
    this.sessionFacade.closeMessages();
  }
}
